;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { VisualCopy } from './types'

/** English: the same screens, in the vocabulary the English pages use elsewhere. */
export const EN: VisualCopy = {
  status: {
    klaar: 'Done ✓',
    loopt: 'In progress',
    controle: 'Review',
    ontvangen: 'Received',
    gepland: 'Scheduled',
    leeg: '—',
  },
  workflow: {
    ontvangen: 'Bookkeeping received',
    uitvoering: 'In progress',
    controle: 'Ready for review',
    afgerond: 'Completed',
  },
  period: {
    month: 'July 2026',
    monthLower: 'July 2026',
    closingBookYear: 'Financial year 2025',
    currentBookYear: 'Financial year 2026',
    currentYear: '2026',
  },
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  monthsFull: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  yearActivity: {
    jaarrekening: { label: 'Annual accounts', short: 'AA' },
    vpb: { label: 'CT', short: 'CT', fullLabel: 'Corporate tax return' },
    kvk: { label: 'KVK', short: 'KVK', fullLabel: 'Chamber of Commerce filing' },
    ib: { label: 'IT', short: 'IT', fullLabel: 'Income tax return' },
  },
  monthActivity: {
    administratie: { label: 'Bookkeeping', short: 'Books', fullLabel: 'Financial bookkeeping' },
    omzetbelasting: { label: 'VAT', short: 'VAT', fullLabel: 'VAT return' },
    salaris: { label: 'Payroll', short: 'Pay', fullLabel: 'Payroll run' },
    loonheffingen: { label: 'Payroll tax', short: 'PT', fullLabel: 'Payroll tax return' },
  },
  teamRole: {
    accountant: 'Accountant',
    relatiebeheerder: 'Account manager',
    assistentAccountant: 'Assistant accountant',
    salarisadministrateur: 'Payroll administrator',
    administrateur: 'Bookkeeper',
  },
  contactRole: {
    directie: 'MANAGEMENT',
    financieleAdministratie: 'FINANCE',
    eigenaar: 'OWNER',
  },
  word: {
    hours: 'hours',
    hoursUnit: 'h',
    hoursWord: 'hours',
    tasks: 'tasks',
    complete: 'complete',
    clients: 'Clients',
    clientsLower: 'clients',
    planned: 'planned',
    of: 'of',
    client: 'Client',
    activity: 'Activity',
    amount: 'Amount',
    project: 'Project',
    description: 'Description',
    owner: 'Owner',
    period: 'Period',
    status: 'Status',
    name: 'Name',
    address: 'Address',
    contract: 'Contract',
    billable: 'Billable',
    checklist: 'Checklist',
    frequency: 'Frequency',
    price: 'Price',
    thisMonth: 'this month',
    perDay: 'per day',
    booked: 'logged',
    dayTotal: 'Day total',
    total: 'Total',
    search: 'Search',
    days: 'days',
    completed: 'completed',
    at: 'at',
    budget: 'Budget',
    used: 'Used',
    workItem: 'Activity',
    by: 'by',
    step: 'Step',
    open: 'Open',
    results: 'results',
    today: 'Today',
    full: 'full',
    room: 'room',
    realised: 'Done',
  },
  screen: {
    aiChat: {
      assistant: 'AI assistant',
      viaMcp: 'AI assistant over MCP',
      planningCaption: 'Ask the planning through an AI assistant',
      askPlanning: 'Ask a question about the planning…',
      askHours: 'Ask a question about the hours…',
      assistantName: 'Offsoo assistant',
    },
    budget: {
      title: 'Budgets',
      caption: 'Budgets per client, with overruns',
      sortedByUse: 'Sorted by usage',
      overBudget: (count) => `${count} over budget`,
    },
    capacity: {
      title: 'Capacity',
      caption: 'Capacity per colleague',
      perMonth: 'Per month',
      perEmployee: 'Per colleague',
      overload: 'May 124% — redistribute',
    },
    clientDossier: {
      title: 'Clients',
      caption: 'Adding a client from the Chamber of Commerce',
      addClient: 'Add client',
      addClientPlus: '+ Add client',
      addViaKvk: 'Add a client from KVK',
      kvkNumber: 'KVK number',
      legalForm: 'Legal form',
      fromKvk: 'From KVK ✓',
      headOffice: 'Head office',
      kvkIntegration: 'KVK integration',
      allClients: 'All clients',
      add: 'Add',
      added: 'Added ✓',
    },
    clientList: {
      caption: 'The client list searched, and one group unfolded',
      ofResults: (total) => `of ${total} results`,
    },
    dossierTabs: {
      caption: (client: string) => `${client}'s file: details, planning, hours and tasks`,
      tabOverview: 'Overview',
      tabPlanning: 'Planning',
      tabHours: 'Hours',
      tabTasks: 'Tasks',
      tabLog: 'Log',
      generalInfo: 'General information',
      contactPeople: 'Contacts',
      accountManagerCard: 'Account manager',
      addressCard: 'Address',
      monthPlanning: 'Monthly planning',
      yearPlanning: 'Yearly planning',
      hoursCard: 'Hours and budget',
      perMemberCard: 'Hours per colleague',
      openTasks: 'Open work',
      hoursLabel: 'Hours',
      billable: 'Billable',
      nonBillable: 'Non-billable',
      leftOfBudget: 'Left of budget',
      ofBudget: 'of the budget',
      perYear: 'per year',
      agreed: 'AGREED',
      subtasks: (done: number, total: number) => `${done} of ${total} subtasks`,
    },
    clientRecord: {
      caption: (client) => `Client dossier for ${client}`,
      general: 'GENERAL INFORMATION',
      addresses: 'ADDRESSES',
      contacts: 'CONTACTS',
      accountManager: 'ACCOUNT MANAGER',
      clientNumber: 'Client number',
      email: 'Email address',
      phone: 'Phone',
      vatNumber: 'VAT number',
      sourceKvk: 'KvK',
      sourceImport: 'Import',
      sourceTeam: 'Team',
    },
    clientLog: {
      caption: (client) => `Files and log for ${client}`,
      files: 'FILES',
      log: 'LOG',
      entry: {
        filed: (member) => `${member} filed the annual accounts with the KVK`,
        taskCompleted: (member) => `${member} ticked off the payroll-tax reconciliation`,
        fileUploaded: (member) => `${member} uploaded the trial balance`,
        vatFiled: (member) => `${member} filed June's VAT return`,
        contactAdded: (member) => `${member} added a contact`,
      },
      kb: 'kB',
    },
    clientRow: { caption: "One client's month on the monthly board" },
    dashboard: {
      title: 'Dashboard',
      caption: 'Dashboard overview',
      myTasks: 'My tasks',
      hoursToday: 'Hours today',
      leadTime: 'Lead time',
      ofPlanned: 'of 8:00 planned',
      goodMorning: 'Good morning',
    },
    employeeHours: {
      title: 'Time tracking',
      caption: 'Hours, leave and overtime per colleague',
      hoursTotal: 'HOURS TOTAL',
      sickHours: 'SICK HOURS',
      leaveBalance: 'LEAVE BALANCE',
      overtime: 'OVERTIME',
      fulltime: 'Full-time contract',
      since: 'since 1 January 2014',
    },
    excel: {
      title: 'From Excel to Offsoo',
      caption: 'From Excel to Offsoo',
      planning: 'Planning',
      monthPlanning: 'Monthly planning',
      fileName: 'Planning2026-FINAL(3).xlsx — Excel',
      lateNote: 'OVERDUE — who is picking this up???',
      copyNote: 'Q3 copy??',
      cells: {
        'zie mail': 'see email',
        'n.v.t.': 'n/a',
        'wie??': 'who??',
        'deels?': 'partly?',
        'tabblad 3?': 'tab 3?',
        'vrijgest.': 'exempt',
      },
    },
    hoursDay: {
      title: 'Log hours',
      caption: 'Logging hours on a day',
      bookedThisDay: 'Logged on this day',
      addHours: 'Add hours',
      noHours: 'No hours on this day.',
      searchClient: 'Search for a client…',
      whatWasWorkedOn: 'What was worked on?',
      saveHours: 'Save hours',
      saved: 'Saved ✓',
    },
    hoursMonth: {
      title: 'Time tracking',
      caption: 'A month of hours, and how one entry counts through it',
    },
    hours: { title: 'Time tracking', addHours: 'Add hours', book: 'Log' },
    integrations: {
      title: 'Connections',
      caption: 'Connections: KVK, open API and MCP',
      kvkIntegration: 'KVK integration',
      kvkBody: 'Name, address and legal form straight from the trade register',
      openApi: 'Open API',
      apiBody: 'Read and write clients, planning, hours and tasks — rights per token',
      mcp: 'MCP connection',
      mcpBody: 'Claude, ChatGPT and other assistants read along',
      apiKey: 'API key',
      copy: 'Copy',
      activeConnections: 'connections active',
      sampleQuestion: 'And who is the account manager?',
      screenTitle: 'Client management',
      active: 'ACTIVE',
      connecting: 'CONNECTING…',
      connected: 'CONNECTED',
      holdingQuestion: (client) => `What is the holding structure of ${client}?`,
      holdingsAnswer: (count) => `${count === 3 ? 'Three' : String(count)} holdings:`,
    },
    jaarplanning: {
      title: 'Annual planning',
      caption: 'Annual planning, financial year 2025 in progress',
      booked: 'Logged ✓',
      chatReply: "Yes, I'll finish those today.",
      activityDone: (activity) => `${activity} completed`,
      chatQuestion: (activity, client) => `Could you finish the ${activity.toLowerCase()} for ${client}?`,
    },
    leadTime: {
      title: 'Lead time',
      caption: 'Lead-time signals',
      threshold: 'signal threshold',
      longestOpen: 'Longest open',
    },
    mobile: {
      captionPlanning: 'Monthly planning per client in the Offsoo app',
      captionHours: 'Logging hours in the Offsoo app',
      captionDossier: 'Client files in the Offsoo app',
      noHoursToday: 'No hours on this day.',
      ownTasks: 'own tasks',
      week: 'Week',
      companyDetails: 'COMPANY DETAILS',
      contact: 'CONTACT',
      activities: 'ACTIVITIES',
      timeSpent: 'TIME SPENT',
      user: 'USER',
      date: 'DATE',
      period: 'PERIOD',
      amount: 'AMOUNT',
      accountNumber: 'BANK ACCOUNT',
      debtorNumber: 'DEBTOR NUMBER',
      vatNumber: 'VAT NUMBER',
      kvk: 'KVK',
      email: 'EMAIL',
      phone: 'PHONE',
      website: 'WEBSITE',
      projects: 'PROJECTS',
      editEntry: 'Edit entry',
      clientDetails: 'Client details',
      chooseClient: 'Choose a client',
      allCount: (count) => `All ${count}`,
      step: (current, total) => `Step ${current} / ${total}`,
      bookkeepingShort: 'BOOKKEEP.',
      vatShort: 'VAT',
    },
    monthPlanning: { title: 'Monthly planning', caption: 'Monthly planning grid' },
    organogram: {
      title: 'Company structure',
      caption: 'The company structure around one client',
      entities: 'entities',
    },
    planningHours: {
      caption: 'Activity completed',
      spentHours: 'Hours spent',
      planned: 'Planned',
      completed: 'Activity completed',
      tickIsBooked: 'Ticking it logs it',
      ticked: 'ticked',
      newEntry: 'new entry',
      addComment: 'Add a comment…',
      send: 'Send',
      sent: 'Sent ✓',
    },
    planningWall: {
      caption: 'The annual planning filtered by colleague and deadline',
      searchUser: 'Search user…',
      searchMonth: 'Search month…',
      searchTags: 'Search tags…',
      month: 'MONTH',
    },
    progress: { caption: 'Progress through the financial year, by month', thisYear: 'this year' },
    recurring: {
      title: 'Setting up a recurring activity',
      caption: 'Setting up a recurring activity',
      chooseFrequency: 'Choose a frequency',
      frequencies: ['Monthly', 'Quarterly', 'Yearly'],
      quarterly: 'Quarterly',
      changePlanning: 'Change planning',
      fileReturn: (activity) => `File the ${activity.toLowerCase()}`,
    },
    reports: {
      title: 'Hours report',
      caption: 'An hours report filtered to what is still to be invoiced',
      actions: 'Actions',
      export: 'Export',
      changeColumns: 'Change columns',
      changeStatus: 'Change status',
      rows: 'rows',
      excel: 'Excel',
      exported: (rows) => `${rows} rows exported to Excel`,
    },
    migration: {
      monthly: 'monthly',
      quarterly: 'quarterly',
      invitesSent: 'Invitations sent',
    },
  },
  content: {
    bookkeepingChecklist: [
      'Import bank statements',
      'Process purchase invoices',
      'Process sales invoices',
      'Process cash administration',
      'Process journal entries',
      'Check open items',
    ],
    bookkeepingChecklistShort: ['Bank statements', 'Purchase invoices', 'Sales invoices'],
    annualAccountsChecklist: ['Draft the annual accounts', 'Write the notes', 'File the annual accounts (KVK)'],
    reviewActivity: 'Quality review of the file',
    myTasks: ['Prepare the Q2 VAT return', 'Review the annual accounts', 'Chase the VAT correction'],
    entryNote: 'Bank transactions and purchase invoices processed',
    conceptNote: 'Draft annual accounts prepared and reconciled',
    hoursRemark: 'hours logged — file ready for review',
    publicationDocs: 'Chamber of Commerce filing documents',
    vatCorrection: 'VAT correction',
    internalMeeting: 'Internal meeting',
    yearEndClose: 'Year-end close of the bookkeeping',
    reportStatus: {
      'te-factureren': 'To invoice',
      gefactureerd: 'Invoiced',
      'niet-facturabel': 'Non-billable',
    },
    awaitingClient: 'Awaiting client approval',
    awaitingClientReply: 'Awaiting client',
    awaitingDocuments: 'Awaiting documents',
    addressTag: { ZAKELIJK: 'BUSINESS', POST: 'POSTAL' },
    netherlands: 'Netherlands',
    legalForm: {
      HOLDING: 'Holding',
      BV: 'BV',
      EENMANSZAAK: 'Sole trader',
      VOF: 'VOF',
      SRL: 'SRL',
      STICHTING: 'Foundation',
    },
    privateLimitedCompany: 'Private limited company',
    newClient: 'New',
    corporateTaxReturn: 'CT return',
    dossierTasks: {
      'Suppletie omzetbelasting nabellen': 'Chase the VAT correction',
      'Jaarrekening 2025 reviewen': 'Review annual accounts 2025',
      'Stukken opvragen bij de klant': 'Request documents from the client',
      'Aansluitcontrole loonheffingen': 'Payroll tax reconciliation',
      'KvK-publicatie deponeren': 'File the KVK publication',
    },
    files: {
      'Kolommenbalans 2025.xlsx': 'Trial balance 2025.xlsx',
      'Jaarrekening 2025.pdf': 'Annual accounts 2025.pdf',
      'Opdrachtbevestiging.pdf': 'Engagement letter.pdf',
    },
  },
  chat: {
    and: ' and ',
    comma: ', ',
    yearWork: {
      question: 'Which annual accounts are still open?',
      followUp: 'And which one has been still the longest?',
      answerLead: 'have not finished their annual accounts.',
      ofWhichOne: 'of those has not started:',
      ofWhichMany: 'of those have not started:',
      openFor: 'open for',
      overThreshold: (days) => `${days} days over the signal threshold.`,
    },
    planning: {
      question: 'Which VAT returns have not started yet?',
      followUp: 'And who has room left this week?',
      allThreeWithDeadline: 'all three due',
      allWithDeadline: 'all due',
      isAt: 'is at',
      enoughRoom: '— room enough to take the returns over.',
    },
    hours: {
      question: 'How many hours did the team log last month?',
      followUp: 'Which clients are over their budget?',
      lastMonth: (hours, month, billable, activity) =>
        `${hours} hours in ${month}, of which ${billable} billable — most of it on ${activity}.`,
      overBudget: (count, list) => `${count === 2 ? 'Two' : String(count)}: ${list}.`,
    },
    leadTime: (days, client) => `${client} has been still ${days} days longer than the signal threshold.`,
  },
}
